export default "__VITE_ASSET__CXu532Il__"